import React, { useContext } from "react";
import "../skills/skills.css";
import Flutter from "../images/Flutter.png";
import javaScript from "../images/javaScript.png";
import Firebase from "../images/Firebase.png";
import docker from "../images/docker.png";
import git from "../images/git.png";
import mysql from "../images/mysql.png";
import nodejs from "../images/nodejs.png";
import react from "../images/react.png";
import typescript from "../images/typescript.png";
import { DataContext } from "../contextAPI";
const Skills = () => {
  const { toggleMode } = useContext(DataContext);
  return (
    <div className={`${toggleMode ? "theme" : "dark-mode"} section`}>
      <div
        className={`skills-text about-me ${
          toggleMode ? "?theme" : "dark-mode"
        }`}
        id="Skills"
      >
        <h2 className="my-skills about-me">Skills</h2>
      </div>
      <div className="skills my-skills">
        <i className="image-circle">
          <img className="image-logo" src={javaScript} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={Firebase} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img
            style={{ marginTop: "-20px" }}
            className="image-logo"
            src={Flutter}
            width="70"
            height="70"
          />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={docker} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={git} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={mysql} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={nodejs} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={react} width="40" height="40" />
        </i>
        <i className="image-circle">
          <img className="image-logo" src={typescript} width="40" height="40" />
        </i>
      </div>
    </div>
  );
};

export default Skills;
